exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ell[data-v-56c8748f]{overflow:hidden;display:inline-block;white-space:nowrap;text-overflow:ellipsis;max-width:112px;color:#000000;vertical-align:bottom;padding-right:0}\n", ""]);

